import * as React from 'react';

const Facebook = (
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="44" height="44" rx="22" fill="#3C5B96" />
		<path
			d="M25.6876 22.5068H23.2748C23.2748 26.3139 23.2748 31 23.2748 31H19.6995C19.6995 31 19.6995 26.3593 19.6995 22.5068H18V19.505H19.6995V17.5634C19.6995 16.1729 20.3686 14 23.3076 14L25.957 14.01V16.9239C25.957 16.9239 24.3471 16.9239 24.034 16.9239C23.721 16.9239 23.276 17.0785 23.276 17.7416V19.5056H26L25.6876 22.5068Z"
			fill="white"
		/>
	</svg>
);

const Vkontakte = (
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="44" height="44" rx="22" fill="#0077FF" />
		<path
			d="M23.0718 29.4879C14.8719 29.4879 10.1949 23.8664 10 14.5122H14.1074C14.2423 21.3779 17.2704 24.2861 19.6689 24.8857V14.5122H23.5366V20.4335C25.9051 20.1787 28.3933 17.4804 29.2328 14.5122H33.1004C32.4558 18.1699 29.7575 20.8682 27.8387 21.9775C29.7575 22.877 32.8307 25.2305 34 29.4879H29.7425C28.8281 26.6396 26.5497 24.436 23.5366 24.1362V29.4879H23.0718Z"
			fill="white"
		/>
	</svg>
);

const Google = (
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="white" />
		<path
			d="M16.9892 23.8775L16.3626 26.2165L14.0726 26.2649C13.3882 24.9956 13 23.5432 13 21.9999C13 20.5074 13.363 19.1001 14.0063 17.8608H14.0068L16.0456 18.2346L16.9387 20.2612C16.7518 20.8061 16.6499 21.3911 16.6499 21.9999C16.65 22.6605 16.7696 23.2935 16.9892 23.8775Z"
			fill="#FBBB00"
		/>
		<path
			d="M30.8427 20.3188C30.9461 20.8633 31 21.4255 31 22.0002C31 22.6445 30.9322 23.273 30.8032 23.8793C30.3651 25.9424 29.2203 27.7438 27.6344 29.0187L27.6339 29.0182L25.066 28.8872L24.7025 26.6184C25.7548 26.0012 26.5772 25.0354 27.0104 23.8793H22.1978V20.3188H27.0806H30.8427Z"
			fill="#518EF8"
		/>
		<path
			d="M27.6339 29.0178L27.6344 29.0183C26.092 30.258 24.1328 30.9998 22 30.9998C18.5726 30.9998 15.5927 29.0841 14.0726 26.2649L16.9892 23.8774C17.7492 25.9059 19.706 27.3499 22 27.3499C22.986 27.3499 23.9098 27.0833 24.7024 26.618L27.6339 29.0178Z"
			fill="#28B446"
		/>
		<path
			d="M27.7447 15.072L24.8291 17.4589C24.0087 16.9461 23.0389 16.6499 22 16.6499C19.6541 16.6499 17.6607 18.1601 16.9387 20.2613L14.0068 17.861H14.0063C15.5042 14.9731 18.5216 13 22 13C24.1837 13 26.186 13.7779 27.7447 15.072Z"
			fill="#F14336"
		/>
		<rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="#D9D9D9" />
	</svg>
);

const close = (
	<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.18198 9.24246L5 6.06048L1.81802 9.24246L0.757359 8.1818L3.93934 4.99982L0.757359 1.81784L1.81802 0.757176L5 3.93916L8.18198 0.757176L9.24264 1.81784L6.06066 4.99982L9.24264 8.1818L8.18198 9.24246Z"
			fill="#262626"
		/>
	</svg>
);

const TinkoffID = (
	<svg width="44" height="44" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.0481415" y="0.284119" width="56" height="56" rx="28" fill="#FFDD2D" />
		<path
			d="M16.0481 16.2841H40.0481V28.3532C40.0481 31.4481 38.4021 34.3014 35.7201 35.8546L28.0539 40.2841L20.3877 35.8546C17.7057 34.3129 16.0597 31.4481 16.0597 28.3532V16.2841H16.0481Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22.6323 22.6349V26.3857C23.1503 25.8104 24.0827 25.4192 25.1416 25.4192H26.3042V29.7797C26.3042 30.9418 25.9934 31.9542 25.5215 32.518H30.5632C30.0913 31.9542 29.7805 30.9418 29.7805 29.7797V25.4192H30.9431C32.0136 25.4192 32.946 25.8104 33.4524 26.3857V22.6349H22.6323Z"
			fill="#333333"
		/>
	</svg>
);

const Telegram = (
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="44" height="44" rx="22" fill="#2CA5E0" />
		<path
			d="M17.8478 25.2041L17.517 29.9505C17.9903 29.9505 18.1953 29.7431 18.4412 29.4941L20.6604 27.3308L25.2588 30.7657C26.1022 31.2451 26.6964 30.9926 26.9239 29.9743L29.9423 15.5482L29.9431 15.5473C30.2106 14.2757 29.4923 13.7785 28.6706 14.0904L10.9285 21.0188C9.71764 21.4982 9.73598 22.1867 10.7227 22.4986L15.2586 23.9376L25.7947 17.2133C26.2905 16.8784 26.7414 17.0637 26.3705 17.3986L17.8478 25.2041Z"
			fill="white"
		/>
	</svg>
);

const SberID = (
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="44" height="44" rx="22" fill="#148F2B" />
		<path
			d="M30.7038 15.2783C31.2337 15.9456 31.6655 16.6913 32.0187 17.4764L22.0098 24.8751L17.81 22.2257V19.066L21.9902 21.6958L30.7038 15.2783Z"
			fill="white"
		/>
		<path
			d="M13.5317 22.0098C13.5317 21.8528 13.5317 21.7351 13.5513 21.5781L11.0196 21.4407C11.0196 21.6173 11 21.8136 11 21.9902C11 25.0321 12.2364 27.7797 14.2382 29.7814L16.0437 27.9759C14.4933 26.4648 13.5317 24.3452 13.5317 22.0098Z"
			fill="white"
		/>
		<path
			d="M21.9901 13.5512C22.1471 13.5512 22.2649 13.5512 22.4219 13.5708L22.5593 11.0392C22.3826 11.0392 22.1864 11.0195 22.0098 11.0195C18.9678 11.0195 16.2203 12.2559 14.2185 14.2577L16.024 16.0632C17.5548 14.5128 19.6743 13.5512 21.9901 13.5512Z"
			fill="white"
		/>
		<path
			d="M21.9902 30.4683C21.8332 30.4683 21.7154 30.4683 21.5584 30.4487L21.421 32.9804C21.5976 32.9804 21.7939 33 21.9705 33C25.0125 33 27.76 31.7636 29.7618 29.7618L27.9563 27.9563C26.4451 29.5263 24.3452 30.4683 21.9902 30.4683Z"
			fill="white"
		/>
		<path
			d="M26.7592 15.0232L28.8984 13.4335C27.0339 11.9224 24.62 11 21.9902 11V13.5317C23.7761 13.5513 25.4247 14.1008 26.7592 15.0232Z"
			fill="white"
		/>
		<path
			d="M33 22.0097C33 21.3425 32.9411 20.6948 32.8233 20.0276L30.4683 21.7939C30.4683 21.8527 30.4683 21.9509 30.4683 22.0097C30.4683 24.5022 29.3889 26.7395 27.6619 28.2702L29.3693 30.1543C31.6066 28.1721 33 25.2479 33 22.0097Z"
			fill="white"
		/>
		<path
			d="M21.9902 30.4683C19.4978 30.4683 17.2605 29.3889 15.7297 27.6619L13.8457 29.3693C15.8671 31.6066 18.7717 33 21.9902 33V30.4683Z"
			fill="white"
		/>
		<path
			d="M16.3381 15.7493L14.6307 13.8652C12.3934 15.867 11 18.7716 11 22.0097H13.5317C13.5317 19.537 14.6111 17.28 16.3381 15.7493Z"
			fill="white"
		/>
	</svg>
);

const AlfaID = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 370 370">
		<rect fill="#ef3124" width="370" height="370" rx="185" />
		<rect fill="#fff" x="114.28" y="258.75" width="141.44" height="29.39" />
		<path
			fill="#fff"
			d="M210.89,94.41c-4.03-12.03-8.68-21.53-24.61-21.53s-20.87,9.46-25.12,21.53l-43.77,124.41h29.02l10.1-29.58h55.84l9.37,29.58h30.86l-41.71-124.41Zm-45.91,69.85l19.84-58.96h.73l18.74,58.96h-39.31Z"
		/>
	</svg>
);

export const icons = {
	Vkontakte,
	Google,
	Facebook,
	TinkoffID,
	Telegram,
	SberID,
	AlfaID,
	close
};
